/**
 * Customer flags as the page shows them — the server's list is
 * chariot-backend/utils/customerFlags.js (keep the two the same). Do Not
 * Service blocks new orders (Phase 3 of the customer profile plan); the
 * others warn. `tone` picks the alert's color family (CustomerProfile.css).
 */
export const FLAG_KINDS = [
  { kind: 'do_not_service', label: 'Do Not Service', tone: 'crit', hint: 'Blocks new orders, except warranty and recall work.' },
  { kind: 'collections', label: 'Collections', tone: 'high', hint: 'Money is owed: take payment before new work.' },
  { kind: 'safety', label: 'Safety', tone: 'high', hint: 'Something techs must know before they go: a dog, a dock, a person.' },
  { kind: 'vip', label: 'VIP', tone: 'info', hint: 'Treat with priority.' },
];

export const flagKind = (kind) => FLAG_KINDS.find((k) => k.kind === kind) || { kind, label: kind, tone: 'info', hint: '' };

export const FLAG_REASON_MAX = 500;
